import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { Shell } from 'App/Shell'
import Splash from 'App/Splash'

import { fetchSimpleWishlist } from 'Wishlist/ducks'
import { fetchCatalog } from 'Catalog/ducks'
import { fetchParticipant } from 'Participant/ducks'
import { fetchRegulationsLGPD } from 'features/RegulationModal/ducks'
import { actions as balanceActions } from 'features/Balance'
import { actions as cardBrandsActions } from 'features/CardBrands'
import { ProductCategoryAction, StoresAction } from 'App/MainMenu'
import { fetchPointPurchaseConfiguration } from 'Checkout/PointsPurchase/ducks'
import { datadogRum } from '@datadog/browser-rum'

class AuthedShell extends Component {
  loadAuthedShell () {
    const {
      profile,
      loadWishlist,
      loadCatalog,
      loadParticipant,
      loadLGPDRegulation,
      loadCategories,
      loadCardBrands,
      loadBalance,
      loadStores,
      loadPurchasePointsConfiguration
    } = this.props

    loadCatalog()
    loadParticipant()
    loadBalance()
    loadWishlist()
    loadLGPDRegulation()
    loadStores(profile['custom:catalog_id'])
    loadCategories()
    loadCardBrands()
    loadPurchasePointsConfiguration()

    datadogRum.setUser({
      id: profile['custom:participant_id'],
      name: profile['name'],
      email: profile['email'],
      username: profile['username']
    })
  }

  componentDidMount () {
    this.loadAuthedShell()
  }

  componentDidUpdate () {
    const { isLoadedCatalog, isLoadingCatalog } = this.props

    if (!isLoadedCatalog && !isLoadingCatalog) {
      this.loadAuthedShell()
    }
  }

  render () {
    const { children, profile, isLoadingCatalog, isLoadedCatalog } = this.props
    return isLoadingCatalog && !isLoadedCatalog
      ? <Splash text='Estamos carregando sua experiência' />
      : <Shell profile={profile}>{children}</Shell>
  }
}

AuthedShell.propTypes = {
  children: PropTypes.node,
  profile: PropTypes.object,
  loadWishlist: PropTypes.func,
  loadCatalog: PropTypes.func,
  isLoadingCatalog: PropTypes.bool,
  isLoadedCatalog: PropTypes.bool,
  loadParticipant: PropTypes.func,
  loadLGPDRegulation: PropTypes.func,
  loadCategories: PropTypes.func,
  loadCardBrands: PropTypes.func,
  loadBalance: PropTypes.func,
  loadStores: PropTypes.func,
  loadPurchasePointsConfiguration: PropTypes.func
}

const mapStateToProps = ({ catalog }) => {
  const { isLoading: isLoadingCatalog, isLoaded: isLoadedCatalog } = catalog

  return { isLoadingCatalog, isLoadedCatalog }
}

const mapDispatchToProps = dispatch => ({
  loadWishlist: () => dispatch(fetchSimpleWishlist()),
  loadCatalog: () => dispatch(fetchCatalog()),
  loadParticipant: () => dispatch(fetchParticipant()),
  loadLGPDRegulation: () => dispatch(fetchRegulationsLGPD()),
  loadCardBrands: () => dispatch(cardBrandsActions.fetchCardBrands()),
  loadStores: catalogId => dispatch(StoresAction(catalogId)),
  loadCategories: () => dispatch(ProductCategoryAction()),
  loadBalance: () => dispatch(balanceActions.loadBalance()),
  loadPurchasePointsConfiguration: () => dispatch(fetchPointPurchaseConfiguration())
})

export default connect(mapStateToProps, mapDispatchToProps)(AuthedShell)



// WEBPACK FOOTER //
// ./src/App/Shell/AuthedShell.js